// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(min-width: 1024px)";
var _5 = "12px";
var _6 = "passengers-MaOUN";
var _7 = "passengers_isMultiCity-2H6SA";
var _8 = "passengers_withCurrency-1jaqC";
var _9 = "selector-zSXNC input-1wrIg";
var _a = "selector_focused-uWmCz input_focused-3NlUn";
var _b = "tooltip__popper-2jV9-";
var _c = "tooltip-tOqeu";
var _d = "arrowIcon-2mdQT";
var _e = "arrowIcon_flipped-2apsX";
var _f = "title-16ZvU";
var _10 = "menu-1Gu5m";
var _11 = "list-1riqb";
var _12 = "item-mdmBN";
var _13 = "controls-2K90m";
var _14 = "info-3crTy";
var _15 = "info__icon-1Ny0R";
var _16 = "passengerType-3aCSM";
var _17 = "age-3QTgN";
var _18 = "increase-TUYp1";
var _19 = "decrease-3jq__";
var _1a = "counter-TFeYK";
var _1b = "counter_disabled-3Uu0Y";
var _1c = "mobileMenu-1Wy6L";
var _1d = "mobileTitle--LN4s";
var _1e = "mobileContent-2qFEz";
var _1f = "modal__Title-j2PsD";
var _20 = "modal__closeButton-3Jx2a";
var _21 = "modal__swipeBlock-2R7Rp";
var _22 = "passengerIcon-1ZtoM";
var _23 = "button-17aVq";
var _24 = "alternative-xr69S";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "desktop_only", _5 as "block_padding", _6 as "passengers", _7 as "passengers_isMultiCity", _8 as "passengers_withCurrency", _9 as "selector", _a as "selector_focused", _b as "tooltip__popper", _c as "tooltip", _d as "arrowIcon", _e as "arrowIcon_flipped", _f as "title", _10 as "menu", _11 as "list", _12 as "item", _13 as "controls", _14 as "info", _15 as "info__icon", _16 as "passengerType", _17 as "age", _18 as "increase", _19 as "decrease", _1a as "counter", _1b as "counter_disabled", _1c as "mobileMenu", _1d as "mobileTitle", _1e as "mobileContent", _1f as "modal__Title", _20 as "modal__closeButton", _21 as "modal__swipeBlock", _22 as "passengerIcon", _23 as "button", _24 as "alternative" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "desktop_only": _4, "block_padding": _5, "passengers": _6, "passengers_isMultiCity": _7, "passengers_withCurrency": _8, "selector": _9, "selector_focused": _a, "tooltip__popper": _b, "tooltip": _c, "arrowIcon": _d, "arrowIcon_flipped": _e, "title": _f, "menu": _10, "list": _11, "item": _12, "controls": _13, "info": _14, "info__icon": _15, "passengerType": _16, "age": _17, "increase": _18, "decrease": _19, "counter": _1a, "counter_disabled": _1b, "mobileMenu": _1c, "mobileTitle": _1d, "mobileContent": _1e, "modal__Title": _1f, "modal__closeButton": _20, "modal__swipeBlock": _21, "passengerIcon": _22, "button": _23, "alternative": _24 }
